import { useState, useEffect } from "react";
import axios from "axios";
import AlertDialog from "./AlertDialog";

const API = "https://erp-xe9u.onrender.com/api";

export default function RipplingSyncButton({ onSynced }) {
  const [connected, setConnected] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [dialog, setDialog] = useState({
    open: false,
    type: "success",
    title: "",
    message: "",
  });

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API}/company-profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setConnected(!!res.data?.plugins?.rippling?.connected);
      } catch {}
    })();
  }, []);

  if (!connected) return null;

  const handleSync = async () => {
    setSyncing(true);
    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.post(
        `${API}/users/rippling-sync`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );
      const lines = [
        `${data.matchedCount} matched, ${data.updatedCount} updated (${data.totalWorkers} Rippling workers).`,
      ];
      if (data.unmatched?.length)
        lines.push(`No match: ${data.unmatched.join(", ")}`);
      if (data.ambiguous?.length)
        lines.push(`Ambiguous (skipped): ${data.ambiguous.join(", ")}`);
      setDialog({
        open: true,
        type:
          data.unmatched?.length || data.ambiguous?.length
            ? "error"
            : "success",
        title: "Rippling Sync Complete",
        message: lines.join("\n"),
      });
      onSynced?.();
    } catch (err) {
      setDialog({
        open: true,
        type: "error",
        title: "Sync Failed",
        message: err.response?.data?.message || "Rippling sync failed.",
      });
    } finally {
      setSyncing(false);
    }
  };

  const close = () => setDialog((p) => ({ ...p, open: false }));

  return (
    <>
      <AlertDialog
        type={dialog.type}
        title={dialog.title}
        message={dialog.message}
        confirmText="OK"
        cancelText="Close"
        open={dialog.open}
        onClose={close}
        onConfirm={close}
      />
      <button
        onClick={handleSync}
        disabled={syncing}
        className="flex items-center gap-1.5 px-3 py-2 text-xs font-semibold text-gray-300 bg-gray-800 hover:bg-gray-700 border border-gray-700 rounded-lg transition-colors disabled:opacity-50"
      >
        <svg
          className={`w-3.5 h-3.5 ${syncing ? "animate-spin" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
        {syncing ? "Syncing…" : "Sync Rippling"}
      </button>
    </>
  );
}
